import React from "react";
import { AiOutlineEye } from "react-icons/ai";
import { BsFuelPumpFill } from "react-icons/bs";
import { MdAirlineSeatReclineExtra } from "react-icons/md";
import { TbEngine, TbStars } from "react-icons/tb";
import { Link } from "react-router-dom";
import { useCart } from "../context/cart";
import toast from "react-hot-toast";
import { GoHeart } from "react-icons/go";

const CarCard = ({ p }) => {
  console.log("cars received", p);

  const [cart, setcart] = useCart();
  const notify = () => toast.success("Added to Favourites Successfully");

  return (
    <>
      <div className="card ">
        <div className="d-flex justify-content-between p-3">
          <p className="lead mb-0 respBrand">{p.brand.name}</p>

          <div
            className=" rounded-circle d-flex align-items-center justify-content-center shadow-1-strong"
            style={{ width: "35px", height: "35px" }}
          >
            <Link
              to={`/brand/${p.brand.slug}`}
              className="text-white mb-0 small"
            >
              <img
                src={p.brand.image[0].url}
                alt={p.brand.name}
                style={{
                  maxWidth: "100%",
                  maxHeight: "150px",
                  objectFit: "contain",
                }}
              />
            </Link>
          </div>
        </div>
        <Link to={`/car/${p.slug}`} className="text-center">
          <img
            src={p.documents[0]?.url}
            alt={p.name}
            style={{
              maxWidth: "100%",
              maxHeight: "130px",
              objectFit: "contain",
            }}
            className="border rounded"
          />
        </Link>
        <div className="card-body">
          <h4
            className="text-center mb-1 respName"
            style={{ fontSize: "18px" }}
          >
            {p.name}
          </h4>
          <p style={{ color: "gray" }}>
            {" "}
            {p.description.length > 50
              ? `${p.description.substring(0, 50)}...`
              : p.description}
          </p>
          <h6 className="respBrand">sh. {Number(p.price).toLocaleString()}</h6>
          <div className="d-flex justify-content-between">
            <h6 className="respBrand">
              <TbEngine size={25} color="#8a2be2" /> {p.engineSize} cc
            </h6>
            <h6 className="respBrand">
              <BsFuelPumpFill color="#8a2be2" /> : {p.fuelType}
            </h6>
          </div>
          <div className="d-flex justify-content-between my-2">
            <h6 className="respBrand">
              <TbStars color="#8a2be2" /> : {p?.safetyrating || 5} stars
            </h6>
            <h6 className="respBrand">
              <MdAirlineSeatReclineExtra color="#8a2be2" /> : {p?.seater || 5}{" "}
              Seater
            </h6>
          </div>
          <div className="text-center">
            <Link
              className="btn my-2"
              style={{
                backgroundColor: "blueviolet",
                color: "white",
              }}
              to={`/car/${p.slug}`}
            >
              <AiOutlineEye size={20} className="pb-1" /> View
            </Link>
            <button
              className="btn btn-outline-primary my-2 mx-3 "
              onClick={() => {
                setcart([...cart, p]);
                localStorage.setItem("cart", JSON.stringify([...cart, p]));
                notify();
              }}
            >
              <GoHeart size={20} className="pb-1" /> Add To Likes
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarCard;
